import { faBuilding, faCheck, faChevronDown, faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedRole, setSelectedDoctor } from "../../store/slices/authSlice";
import './nav-bar.scss'

const AppNavBar = () => {
  const { user, userRoles, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const roles = Array.isArray(userRoles) ? userRoles : [];

  const items = roles.map((data) => {
    const isCurrent = selectedRole?._id === data?._id;
    return {
      key: data?._id,
      label: (
        <div className={"chamber-menu-item" + (isCurrent ? " chamber-menu-item--current" : "")}>
          <span className="chamber-menu-item__check">
            {isCurrent && <FontAwesomeIcon icon={faCheck} />}
          </span>
          <span className="chamber-menu-item__text">
            <span className="chamber-menu-item__name">
              {data?.location?.name || "Unnamed chamber"}
            </span>
            {data?.location?.organization?.name && (
              <span className="chamber-menu-item__org">
                {data.location.organization.name}
              </span>
            )}
          </span>
        </div>
      ),
    };
  });

  const onMenuClick = ({ key }) => {
    const role = roles.find((r) => r?._id === key);
    if (role && role._id !== selectedRole?._id) {
      dispatch(setSelectedRole(role));
    }
  };

  // Staff/assistant users act on behalf of one of their tagged ("parent") doctors.
  const userType = user?.user?.type?.toLowerCase();
  const isStaffLike = userType === "staff" || userType === "assistant";
  const parentDoctors = Array.isArray(selectedRole?.parentUsers) ? selectedRole.parentUsers : [];

  const doctorItems = parentDoctors.map((doc) => {
    const isCurrent = selectedDoctor?._id === doc?._id;
    return {
      key: doc?._id,
      label: (
        <div className={"chamber-menu-item" + (isCurrent ? " chamber-menu-item--current" : "")}>
          <span className="chamber-menu-item__check">
            {isCurrent && <FontAwesomeIcon icon={faCheck} />}
          </span>
          <span className="chamber-menu-item__text">
            <span className="chamber-menu-item__name">{doc?.name || "Unnamed doctor"}</span>
            {doc?.email && <span className="chamber-menu-item__org">{doc.email}</span>}
          </span>
        </div>
      ),
    };
  });

  const onDoctorMenuClick = ({ key }) => {
    const doc = parentDoctors.find((d) => d?._id === key);
    if (doc && doc._id !== selectedDoctor?._id) {
      dispatch(setSelectedDoctor(doc));
    }
  };

  return (
    <nav
      className="main-header navbar navbar-expand custom-nav-bar navbar-size main-content my-0 py-0 pt-1"
      style={{ marginLeft: "70px" }}
    >
      <div className="custom-nav-bar__doctor">
        <span className="custom-nav-bar__doctor-name bolder">{user?.user?.name}</span>
      </div>

      <div className="custom-nav-bar__spacer" />

      {isStaffLike && (
        <Dropdown
          trigger={["click"]}
          placement="bottomRight"
          overlayClassName="chamber-dropdown"
          disabled={parentDoctors.length === 0}
          menu={{
            items: doctorItems,
            selectable: true,
            selectedKeys: selectedDoctor?._id ? [selectedDoctor._id] : [],
            onClick: onDoctorMenuClick,
          }}
        >
          <button
            type="button"
            className="custom-nav-bar__doctor-pick"
            aria-label="Switch doctor"
            title="Active doctor"
          >
            <FontAwesomeIcon icon={faUserDoctor} className="custom-nav-bar__doctor-pick-icon" />
            <span className="custom-nav-bar__doctor-pick-current">
              {parentDoctors.length === 0
                ? "No doctor assigned"
                : selectedDoctor?.name || "Select doctor"}
            </span>
            <FontAwesomeIcon icon={faChevronDown} className="custom-nav-bar__doctor-pick-caret" />
          </button>
        </Dropdown>
      )}

      <Dropdown
        trigger={["click"]}
        placement="bottomRight"
        overlayClassName="chamber-dropdown"
        disabled={roles.length === 0}
        menu={{
          items,
          selectable: true,
          selectedKeys: selectedRole?._id ? [selectedRole._id] : [],
          onClick: onMenuClick,
        }}
      >
        <button
          type="button"
          className="custom-nav-bar__chamber"
          aria-label="Switch chamber"
          title="Active chamber"
        >
          <FontAwesomeIcon icon={faBuilding} className="custom-nav-bar__chamber-icon" />
          <span className="custom-nav-bar__chamber-current">
            {selectedRole?.location?.name || "Select chamber"}
          </span>
          <FontAwesomeIcon icon={faChevronDown} className="custom-nav-bar__chamber-caret" />
        </button>
      </Dropdown>
    </nav>
  );
};

export default AppNavBar;
